import { render, staticRenderFns } from "./projectuseredit.vue?vue&type=template&id=0b07a48e"
import script from "./projectuseredit.vue?vue&type=script&lang=js"
export * from "./projectuseredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports